import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'TicketOrder',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TicketOrder',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TicketOrder',
    column_type: 'datetime',
  },
  number: {
    model_name: 'TicketOrder',
    column_type: 'string',
  },
  amount_cents: {
    model_name: 'TicketOrder',
    column_type: 'integer',
  },
  state: {
    model_name: 'TicketOrder',
    column_type: 'enum',
  },
  user: {
    model_name: 'TicketOrder',
    column_type: 'string',
  },
  creator: {
    model_name: 'TicketOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUsersRole',
      foreign_key: 'creator_id',
    },
  },
  creator_id: {
    model_name: 'TicketOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUsersRole',
      foreign_key: 'creator_id',
    },
  },
  ticket_event: {
    model_name: 'TicketOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket_event',
      model_name: 'TicketEvent',
      foreign_key: 'ticket_event_id',
    },
  },
  ticket_event_id: {
    model_name: 'TicketOrder',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket_event',
      model_name: 'TicketEvent',
      foreign_key: 'ticket_event_id',
    },
  },
  paid_at: {
    model_name: 'TicketOrder',
    column_type: 'string',
  },
  ticket_number_start_at: {
    model_name: 'TicketOrder',
    column_type: 'integer',
  },
  ticket_order_items: {
    model_name: 'TicketOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'ticket_order_items',
      model_name: 'TicketOrderItem',
      foreign_key: 'ticket_order_id',
    },
  },
  ticket_order_item_ids: {
    model_name: 'TicketOrder',
    column_type: 'has_many',
    extra: {
      association_name: 'ticket_order_items',
      model_name: 'TicketOrderItem',
      foreign_key: 'ticket_order_id',
    },
  },
  ticket_export_status: {
    model_name: 'TicketOrder',
    column_type: 'enum',
  },
  export_tickets_file: {
    model_name: 'TicketOrder',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  export_tickets_file_with_audio: {
    model_name: 'TicketOrder',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 5,
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
